if (!customElements.get("lookbook-modal")) {
  customElements.define(
    "lookbook-modal",
    class LookbookModal extends ModalDialog {
      get closeCursor() {
        return this.querySelector("modal-close-cursor");
      }

      show(opener) {
        super.show(opener);
        this.closeCursor?.activate();
      }

      hide() {
        super.hide();
        this.closeCursor?.deactivate();
      }
    }
  );
}
